import ApiService from "services/ApiService";

const badRequestCode = 400;

export const ApiRequestService = {

    get (microservice, endpoint, config) {
        return new Promise((resolve, reject) => {
            const url = `/${microservice}/${endpoint}`;
            const request = config == null ? ApiService.get(url) : ApiService.get(url, config);
            request.then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                });
        });
    },
    post(microservice, endpoint, params, errorMessage, config) {
        return new Promise((resolve, reject) => {
            const url = `/${microservice}/${endpoint}`;
            const request = config == null ? ApiService.post(url, params) : ApiService.post(url, params, config);
            request.then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    // A timeout or network failure carries no response.
                    if (errorMessage) {
                        if (error.response?.status === badRequestCode) {
                            reject(error.response.data);
                        } else {
                            reject(errorMessage);
                        }
                    } else {
                        reject(error.response);
                    }
                });
        });
    },
    put(microservice, endpoint, params) {
        return new Promise((resolve, reject) => {
            ApiService.put(`/${microservice}/${endpoint}`, params).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error.response);
                });
        });
    },
    patch(microservice, endpoint, params) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/${microservice}/${endpoint}`, params).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error.response);
                });
        });
    },
    delete(microservice, endpoint) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/${microservice}/${endpoint}`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error.response);
                });
        });
    }
};

export default ApiRequestService;